/**
 * This function will format the full name, capitalizing the first letter of each word.
 * @param {string} fullname - The full name.
 * @return {string} The full name with the first letter of each word capitalized.
 */
export function fullNameFormat(fullname) {
  if (typeof fullname === 'string' || fullname instanceof String) {
    const wordList = fullname.split(' ');
    const capitalizedWordList = wordList.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    const find = ',';
    const re = new RegExp(find, 'g');
    return capitalizedWordList.toString().replace(re, ' ');
  }
  throw new Error(
    'The type of variable is not correct, it must be of type string.'
  );
}
